import style from './article-preview-medium.module.scss';
import Image from 'next/image'
import Link from 'next/link';
import { IArticle } from '@models/article.interface';
import ReadingTimeBlock from '@components/blog/reading-time-block/reading-time';
import * as DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
interface ArticlePreviewMediumProps {
    article: IArticle
}

const ArticlePreviewMedium = ({ article }: ArticlePreviewMediumProps) => {
    const [articleDiscription, setArticleDiscription] = useState<string>('');
    useEffect(() => {
        setArticleDiscription(DOMPurify.sanitize(article.description,{FORBID_ATTR: ['style', 'id']}))
       },[]);

    return (
        <Link scroll={false} href={`/blog/${article.slug}`}>
        
        <div className={style.blogs__item}>
            <div className={style.blogs__image}>
                <Link scroll={false} href={`/blog/${article.slug}`}>
                    <a>
                        <Image sizes="1024px" layout={'fill'} src={article.posterUrl} alt={article.header} />
                    </a>
                </Link>
            </div>
            <div className={style.blogs__content}>
                <h3  className={style.blogs__content__title}>
                    <Link scroll={false} href={`/blog/${article.slug}`}>
                        <a>
                            {article.header}
                        </a>
                    </Link>
                </h3>
                <div className={style.blogs__content__subtitle}>
                    <div dangerouslySetInnerHTML={{
                        __html:articleDiscription
                    }}></div>
                </div>
                <ReadingTimeBlock readingTime={article.readingTime} articleLabel={article.label} />
            </div>
        </div>
        </Link>

    )
}

export default ArticlePreviewMedium;
